import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import { getMetricIconOption } from "./metricOptions";

const useStyles = makeStyles(() => ({
  root: {
    display: "inline-flex",
    alignItems: "center",
    gap: "8px",
    minWidth: 0,
  },
  icon: {
    color: "#E00186",
    flexShrink: 0,
  },
}));

const MetricIconPreview = ({ iconKey, showLabel }) => {
  const classes = useStyles();
  const iconOption = getMetricIconOption(iconKey);
  const IconComponent = iconOption.IconComponent;

  return (
    <span className={classes.root}>
      <IconComponent className={classes.icon} fontSize="small" />
      {showLabel && (
        <Typography variant="body2" component="span">
          {iconOption.label} - {iconOption.description}
        </Typography>
      )}
    </span>
  );
};

export default MetricIconPreview;
